import { render, staticRenderFns } from "./PageManagement.vue?vue&type=template&id=787608bc&scoped=true&"
import script from "./PageManagement.vue?vue&type=script&lang=ts&"
export * from "./PageManagement.vue?vue&type=script&lang=ts&"
import style0 from "./PageManagement.vue?vue&type=style&index=0&id=787608bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787608bc",
  null
  
)

export default component.exports